type Props = {
  selected: boolean;
  onToggle: () => void;
  valorUma: number;
  valorAmbas: number;
  cupomCodigo: string | null;
  valorAmbasFinal?: number | null;
};

function fmt(v: number) {
  return v.toFixed(2).replace('.', ',');
}

export default function PackageDuploCard({ selected, onToggle, valorUma, valorAmbas, cupomCodigo, valorAmbasFinal }: Props) {
  const ambasReal = valorAmbasFinal != null ? valorAmbasFinal : valorAmbas;
  const economia = valorUma * 2 - ambasReal;

  return (
    <div className={`mz-pkg ${selected ? 'mz-pkg-selected' : ''}`}>
      <button
        type="button"
        onClick={onToggle}
        className="mz-pkg-btn"
        aria-pressed={selected}
      >
        {/* Selo "presente em dobro" */}
        <div className="mz-pkg-seal" aria-hidden>
          <svg viewBox="0 0 80 80" width="100%" height="100%">
            <defs>
              <path id="mz-pkg-circle" d="M 40,40 m -30,0 a 30,30 0 1,1 60,0 a 30,30 0 1,1 -60,0" />
            </defs>
            <circle cx="40" cy="40" r="34" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 4" opacity="0.55" />
            <text fill="currentColor" fontSize="7.5" fontWeight="700" letterSpacing="3">
              <textPath href="#mz-pkg-circle" startOffset="0">
                · PRESENTE EM DOBRO · LEVE AS DUAS ·
              </textPath>
            </text>
            <g transform="translate(40,40)">
              <text textAnchor="middle" y="-2" fontSize="13" fontWeight="800" fontFamily="'Playfair Display', serif" fontStyle="italic" fill="currentColor">I</text>
              <text textAnchor="middle" y="11" fontSize="13" fontWeight="800" fontFamily="'Playfair Display', serif" fontStyle="italic" fill="currentColor">II</text>
            </g>
          </svg>
        </div>

        <div className="mz-pkg-text">
          <div className="mz-pkg-tag">
            <span>·</span> Quer levar <strong>as duas</strong>? <span>·</span>
          </div>
          <div className="mz-pkg-title">
            <em>Versão I</em> + <em>Versão II</em>
          </div>
          <div className="mz-pkg-desc">
            Duas músicas pra família ouvir e compartilhar com todo mundo
          </div>

          <div className="mz-pkg-pricing">
            <div className="mz-pkg-pricing-line">
              <span className="mz-pkg-price-from">de R$ {fmt(valorUma * 2)}</span>
              <span className="mz-pkg-price-to">por R$ {fmt(ambasReal)}</span>
            </div>
            {economia > 0.5 && (
              <div className="mz-pkg-economy">
                economia de R$ {fmt(economia)}{cupomCodigo ? ' com o cupom' : ''}
              </div>
            )}
          </div>
        </div>

        <div className="mz-pkg-check" aria-hidden>
          {selected ? (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          )}
        </div>
      </button>

      <style>{`
        .mz-pkg {
          margin: 0 16px 22px;
        }

        .mz-pkg-btn {
          position: relative;
          width: 100%;
          display: grid;
          grid-template-columns: 60px 1fr 32px;
          gap: 14px;
          align-items: center;
          padding: 18px 18px 18px 16px;
          background:
            linear-gradient(135deg, rgba(255,176,122,0.18) 0%, rgba(255,145,77,0.05) 100%),
            #fff;
          border: 2px dashed rgba(255,145,77,0.42);
          border-radius: 18px;
          cursor: pointer;
          text-align: left;
          color: var(--text-strong);
          font-family: 'DM Sans', sans-serif;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 1px 0 rgba(255,255,255,0.7) inset;
        }
        .mz-pkg-btn:hover {
          background:
            linear-gradient(135deg, rgba(255,176,122,0.28) 0%, rgba(255,145,77,0.08) 100%),
            #fff;
          transform: translateY(-1px);
          box-shadow: 0 8px 22px -10px rgba(204,102,32,0.32);
        }
        .mz-pkg-btn:focus-visible {
          outline: 3px solid var(--gold-pale);
          outline-offset: 2px;
        }

        html[data-theme='dark'] .mz-pkg-btn {
          background:
            linear-gradient(135deg, rgba(255,145,77,0.18) 0%, rgba(255,145,77,0.05) 100%),
            rgba(255,255,255,0.04);
          border-color: rgba(255,145,77,0.32);
        }

        .mz-pkg-selected .mz-pkg-btn {
          background: linear-gradient(135deg, var(--gold) 0%, var(--amber-deep) 100%);
          border: 2px solid #fff;
          color: #fff;
          box-shadow:
            0 12px 30px -8px rgba(204,102,32,0.55),
            0 0 0 1px var(--gold-hover);
        }
        .mz-pkg-selected .mz-pkg-btn:hover { transform: translateY(-1px); }

        .mz-pkg-seal {
          color: var(--amber-deep);
          opacity: 0.78;
          width: 60px;
          height: 60px;
          flex-shrink: 0;
          animation: mz-pkg-spin 22s linear infinite;
        }
        @keyframes mz-pkg-spin {
          from { transform: rotate(0); }
          to   { transform: rotate(360deg); }
        }
        .mz-pkg-selected .mz-pkg-seal { color: #fff; opacity: 0.96; }

        .mz-pkg-text {
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 0;
        }

        .mz-pkg-tag {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--amber-deep);
          opacity: 0.85;
        }
        .mz-pkg-tag span { opacity: 0.5; }
        .mz-pkg-selected .mz-pkg-tag { color: rgba(255,255,255,0.85); }
        .mz-pkg-selected .mz-pkg-tag span { opacity: 0.55; }

        .mz-pkg-title {
          font-family: 'Playfair Display', 'Source Serif 4', serif;
          font-weight: 700;
          font-size: 19px;
          line-height: 1.15;
          letter-spacing: -0.02em;
        }
        .mz-pkg-title em {
          font-style: italic;
          color: var(--gold);
        }
        .mz-pkg-selected .mz-pkg-title em { color: #fff; }

        .mz-pkg-desc {
          font-size: 12.5px;
          line-height: 1.45;
          color: var(--text-muted);
          margin-top: 2px;
        }
        .mz-pkg-selected .mz-pkg-desc { color: rgba(255,255,255,0.88); }

        .mz-pkg-pricing {
          display: flex;
          flex-direction: column;
          gap: 3px;
          margin-top: 8px;
        }

        .mz-pkg-pricing-line {
          display: flex;
          align-items: baseline;
          gap: 10px;
          flex-wrap: wrap;
        }

        .mz-pkg-price-from {
          font-size: 12.5px;
          font-weight: 600;
          color: var(--text-soft);
          text-decoration: line-through;
          font-variant-numeric: tabular-nums;
        }
        .mz-pkg-selected .mz-pkg-price-from {
          color: rgba(255,255,255,0.65);
        }

        .mz-pkg-price-to {
          font-family: 'DM Sans', sans-serif;
          font-size: 22px;
          font-weight: 800;
          color: var(--amber-deep);
          letter-spacing: -0.02em;
          font-variant-numeric: tabular-nums;
        }
        .mz-pkg-selected .mz-pkg-price-to { color: #fff; }

        .mz-pkg-economy {
          font-size: 11.5px;
          font-weight: 600;
          color: #1f8a5b;
          letter-spacing: 0.02em;
        }
        .mz-pkg-selected .mz-pkg-economy { color: #d2ffe5; }

        .mz-pkg-check {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgba(255,145,77,0.18);
          color: var(--amber-deep);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.22s;
        }
        .mz-pkg-selected .mz-pkg-check {
          background: #fff;
          color: var(--amber-deep);
          transform: scale(1.08);
        }

        @media (min-width: 720px) {
          .mz-pkg { margin: 0 auto 26px; max-width: 660px; }
        }
      `}</style>
    </div>
  );
}
